import api from './api';
export default {
  _user: null,
  async getUser() {
    try {
      const response = await api.get('user');
      this._user = response.data;
      return {
        isOk: true,
        data: response.data
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message
      };
    }
  },
  getUserRoleId() {
    if (this._user) {
      return this._user.role_id;
    }
    return null;
  },
  getUserAllowedRayons() {
    if (this._user) {
      return this._user.allowed_rayon;
    }
    return null;
  },
  async logIn(email, password) {
    try {
      const response = await api.post('login', {
        email,
        password
      });
      const { access_token } = response.data;
      localStorage.setItem('auth_token', access_token);
      api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      const userResponse = await this.getUser();
      return {
        isOk: true,
        data: userResponse.data
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message
      };
    }
  },

  async logOut() {
    try {
      //await api.post('logout');
      localStorage.removeItem('auth_token');
      delete api.defaults.headers.common['Authorization'];
      this._user = null;
      return {
        isOk: true
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message
      };
    }
  },

  async resetPassword(email) {
    try {
      const response = await api.post('forgot-password', {
        email
      });
      return {
        isOk: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message
      };
    }
  },

  async changePassword(email, recoveryCode, password) {
    try {
      const response = await api.post('reset-password', {
        email,
        recovery_code: recoveryCode,
        password
      });
      return {
        isOk: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message
      };
    }
  },

  async createAccount(email, name, cabang_id, password) {
    try {
      const response = await api.post('register', {
        email,
        name,
        cabang_id,
        password
      });
      const { token } = response.data;
      localStorage.setItem('auth_token', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const userResponse = await this.getUser();
      return {
        isOk: true,
        data: userResponse.data
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message
      };
    }
  },

  async loggedIn() {
    const authToken = localStorage.getItem('auth_token');
    if (authToken) {
      api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
      if((await this.getUser()).isOk){
        return !!this._user;
      }else{
        return false;
      }
    } else {
      //console.log('authTokenFail');
      return false;
    }
  },
};